import axios from 'axios';

const token = document.querySelector('meta[name="csrf-token"]')
    ? document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    : '';

const xmlUnsafeRequest = axios.create({
    headers: {
        'Content-Type': 'multipart/form-data',
        common: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-Csrf-Token': token,
        },
    },
});

xmlUnsafeRequest.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 419) {
            alert('Ваша сессия истекла. Страница будет перезагружена.');
            window.location.reload();
        }

        return Promise.reject(error);
    }
);

export { xmlUnsafeRequest };
